export const AVERAGE_RATING_LABEL = 'Average Rating';
export const RATING_BREAKDOWN_UNAVAILABLE = 'Rating breakdown not available';

export const NO_RATING_PLACEHOLDER = '-';

export const RATING_ACCENT_COLOR = '#fa8c16';
export const RATING_TRACK_COLOR = '#f0f0f0';

// Our own class on the overlay root, rather than antd's internals.
export const RATING_POPOVER_CLASS = 'rating-distribution-popover';

export const POPOVER_WIDTH = 340;
export const POPOVER_BORDER_RADIUS = 2;
export const POPOVER_PADDING = 12;

export const getRatingsLabel = (total: string) => `${total} ratings`;
